var _excluded = ["appearance", "aria-label", "aria-labelledby", "className", "controlId", "keepMounted", "mode", "onChangeTab", "selectedTabId", "tabs", "type"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import TabList from './tab_list/tabs_list';
import TabPanel from './tab_panel';
import { tabsPropTypes } from './prop_types';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Tabs = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      appearance,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledby,
      className,
      controlId,
      keepMounted = false,
      mode,
      onChangeTab,
      selectedTabId,
      tabs = [],
      type = 'online'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var isAttached = type === 'attached';
  var isNoContentPanel = isAttached && tabs.every(tab => !tab.content);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(TabList, _extends({
    appearance: appearance,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    className: className,
    controlId: controlId,
    mode: mode,
    onChangeTab: onChangeTab,
    selectedTabId: selectedTabId,
    tabs: tabs,
    type: type,
    ref: ref
  }, props)), !isNoContentPanel && tabs.map(tab => {
    var isSelected = tab.id === selectedTabId;
    return ___EmotionJSX(TabPanel, {
      appearance: appearance,
      content: tab.content,
      controlId: "".concat(controlId, "-").concat(tab.id),
      isSelected: isSelected,
      keepMounted: keepMounted,
      key: "".concat(tab.id, "-panel"),
      id: tab.id,
      type: type
    });
  }));
});
Tabs.propTypes = tabsPropTypes;
Tabs.displayName = 'Tabs';
export default Tabs;